export enum LogType {
  // 物料单
  ENTRY = 1,
  // 投料单
  INPUT,
  // 报工单
  OUTPUT,
  // 单位配置
  UNITCONFIF,
  // 设备台账
  LEDGER,
  // mes数据
  MES,
  // 查询时间段
  PERIOD,
  // 高杆灯
  GGD,
  // 站房
  STATION,
  // 设备台账批量绑定资产信息模板
  ASSET_TEMPLATE,
}
